import qs from 'query-string';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { createCustomCell } from '../../components/SavedSearchesTable/utils';
import { WORKFLOW_STEP } from '../../constants/Urls';
import { getTranslations } from '../../form-designer/selectors/common.selectors';

const NavigateLinkCell = ({ row, column }) => {
  const translations = useSelector(getTranslations);
  const { entityName, searchName } = qs.parse(location.search);
  return (
    <Link
      to={{
        pathname: WORKFLOW_STEP,
        search: qs.stringify({
          entityType: row.EntityType,
          entityName,
          formKey: row.FormKey,
          itmId: row.ItmId,
          searchName,
        }),
      }}
      style={{ color: '#06C' }}
      aria-label={entityName}
    >
      {createCustomCell(column, translations)({ row })}
    </Link>
  );
};

NavigateLinkCell.fromColumn = (column) => ({ row }) => {
  const props = { row, column };

  return <NavigateLinkCell {...props} />;
};

export default NavigateLinkCell;
